import { Component, computed, inject } from '@angular/core';
import { CustomWidget } from '../widget';
import { CommonModule } from '@angular/common';
import { WidgetType } from '@constants/widgets';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';
import { NumberPipe } from '@pipes/number.pipe';
import { TranslateService } from '@ngx-translate/core';
import { t } from '@utils/strings';

@Component({
  selector: 'abb-list-with-target-widget',
  standalone: true,
  imports: [CommonModule, TPipe, NumberPipe],
  template: `
    <table class="w-full min-h-[100%]">
      <thead>
        <tr>
          @for (col of columns(); track $index) {
          <th [ngClass]="['px-2']" [innerHTML]="(col.name | t).toUpperCase()">
            
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track $index) {
        <tr class="border border-abb-black/10 odd:bg-abb-black/[0.02]">
          @for (col of columns(); track col.key) {
          <td
            [ngClass]="{
              'py-1 px-2 text-center': true,
              'text-abb-success font-semibold': col.key !== 'name' && row.value <= row.target,
              'text-abb-error font-bold': col.key !== 'name' && row.value > row.target,
              'text-abb-font/80': col.key === 'name'
            }"
          >
            @if (col.key === 'name') {

            {{ row[col.key] }}
            } @else {
              <span [innerHTML]="(row[col.key] | number:{ maximumFractionDigits: 2 }) + ' ' + unit()"></span>
            }
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  `,
  styles: ``,
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'dashboards.list_with_target_widget',
    },
  ],
})
export class ListWithTargetWidgetComponent extends CustomWidget {
  translationService = inject(TranslateService);
  prefix = inject(TRANSLATION_PREFIX);
  rows = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'ListWithTargetData') {
      return data.itemsWithTarget;
    }
    return [];
  });

  unit = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'ListWithTargetData') {
      return t(this.prefix, data.unit, this.translationService); 
    }
    return '';
  });

  columns = computed(() => [
    {
      key: 'name' as const,
      name:
        this.widget().type === WidgetType.CO2_EMISSIONS
          ? 'Selected properties'
          : 'Name',
    },
    {
      key: 'value' as const,
      name:
        this.widget().type === WidgetType.CO2_EMISSIONS
          ? 'CO2 emissions'
          : 'Value',
    },
    { key: 'target' as const, name: 'Target' },
  ]);
}
